import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { saleimg } from "../Constant/Index";
import { Link } from "react-router-dom";

const Testimonials = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Testimonials" />
			<section className="testemonial">
				<div className="container">
					<div className="row">
						<div class="col-lg-12 mt-3">
							<div class="content-qty extra-bg-14 radius-20 pe-5 ps-5 p-4 dark-color ">
								<div className="d-flex align-items-center justify-content-between">
									<div className="d-flex gap-3 align-items-center">
										<img src={saleimg} className="img-fluid" alt="" />
										<div>
											<h4 class="primary-medium-font level-7  mb-0">
												Wade Warren
											</h4>
											<h5 class="primary-medium-font level-8 extra-color-15">
												President of Sales{" "}
											</h5>
										</div>
									</div>
									<div class="stars">
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
									</div>
								</div>
								<p class="primary-medium-font level-8 dark-color mt-3">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									laboris nisi ut aliquip ex ea commodo consequat. Duis aute
									irure dolor in reprehenderit in voluptate velit esse cillum
									dolore eu fugiat nulla pariatur. Excepteur sint occaecat
									cupidatat non proident, sunt in culpa qui officia deserunt
									mollit anim id est laborum.
								</p>
								<h4 className="primary-medium-font level-8 extra-color-10">
									Posted a Month ago
								</h4>
							</div>
						</div>
						<div class="col-lg-12 mt-3">
							<div class="content-qty extra-bg-14 radius-20 pe-5 ps-5 p-4 dark-color ">
								<div className="d-flex align-items-center justify-content-between">
									<div className="d-flex gap-3 align-items-center">
										<img src={saleimg} className="img-fluid" alt="" />
										<div>
											<h4 class="primary-medium-font level-7  mb-0">
												Wade Warren
											</h4>
											<h5 class="primary-medium-font level-8 extra-color-15">
												President of Sales{" "}
											</h5>
										</div>
									</div>
									<div class="stars">
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
									</div>
								</div>
								<p class="primary-medium-font level-8 dark-color mt-3">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									laboris nisi ut aliquip ex ea commodo consequat. Duis aute
									irure dolor in reprehenderit in voluptate velit esse cillum
									dolore eu fugiat nulla pariatur. Excepteur sint occaecat
									cupidatat non proident, sunt in culpa qui officia deserunt
									mollit anim id est laborum.
								</p>
								<h4 className="primary-medium-font level-8 extra-color-10">
									Posted a Month ago
								</h4>
							</div>
						</div>
						<div class="col-lg-12 mt-3">
							<div class="content-qty extra-bg-14 radius-20 pe-5 ps-5 p-4 dark-color ">
								<div className="d-flex align-items-center justify-content-between">
									<div className="d-flex gap-3 align-items-center">
										<img src={saleimg} className="img-fluid" alt="" />
										<div>
											<h4 class="primary-medium-font level-7  mb-0">
												Wade Warren
											</h4>
											<h5 class="primary-medium-font level-8 extra-color-15">
												President of Sales{" "}
											</h5>
										</div>
									</div>
									<div class="stars">
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
									</div>
								</div>
								<p class="primary-medium-font level-8 dark-color mt-3">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									laboris nisi ut aliquip ex ea commodo consequat. Duis aute
									irure dolor in reprehenderit in voluptate velit esse cillum
									dolore eu fugiat nulla pariatur. Excepteur sint occaecat
									cupidatat non proident, sunt in culpa qui officia deserunt
									mollit anim id est laborum.
								</p>
								<h4 className="primary-medium-font level-8 extra-color-10">
									Posted a Month ago
								</h4>
							</div>
						</div>
						<div class="col-lg-12 mt-3">
							<div class="content-qty extra-bg-14 radius-20 pe-5 ps-5 p-4 dark-color ">
								<div className="d-flex align-items-center justify-content-between">
									<div className="d-flex gap-3 align-items-center">
										<img src={saleimg} className="img-fluid" alt="" />
										<div>
											<h4 class="primary-medium-font level-7  mb-0">
												Wade Warren
											</h4>
											<h5 class="primary-medium-font level-8 extra-color-15">
												President of Sales{" "}
											</h5>
										</div>
									</div>
									<div class="stars">
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
										<i class="fas fa-star"></i>
									</div>
								</div>
								<p class="primary-medium-font level-8 dark-color mt-3">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									laboris nisi ut aliquip ex ea commodo consequat. Duis aute
									irure dolor in reprehenderit in voluptate velit esse cillum
									dolore eu fugiat nulla pariatur. Excepteur sint occaecat
									cupidatat non proident, sunt in culpa qui officia deserunt
									mollit anim id est laborum.
								</p>
								<h4 className="primary-medium-font level-8 extra-color-10">
									Posted a Month ago
								</h4>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12">
							<div className="text-center">
								<Link
									class="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none"
									href="/personal-info"
								>
									<span class="bg-wrapper ">Load more</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Footer />
		</>
	);
};

export default Testimonials;
